module.exports = __webpack_public_path__ + "static/media/averta-bold.b2fed317.woff";